let resumeData = {
  imagebaseurl: "https://rbhatia46.github.io/",
  name: "AAKASH",
  role: "FULLSTACK WEB DEVELOPER",
  linkedinId: " https://www.linkedin.com/in/aakash-kumar-aaaa68174/",
  upworkId: "https://www.upwork.com/freelancers/~0151dca73d554411ad",
  skypeId: "https://join.skype.com/invite/WyWt23ASh5rl",
  roleDescription:
    " Welcome to my Portfolio website. I have been in this industry from 2018. I am now comfortable with a bunch of frontend and backend technologies and frameworks and ready to boost your ideas to the market by the means of any of them or even combine a suitable mix of appropriate tools.",
  socialLinks: [
    {
      name: "phone",
      src: "devicon",
      url: "tel:+917404396642",
      className: "fas fa-phone",
    },
    {
      name: "gmail",
      src: "devicon",
      url: "mailto:aakash20kumar@gmail.com",
      className: "far fa-envelope-open",
    },
    {
      name: "linkedin",
      src: "devicon",
      url: "https://www.linkedin.com/in/aakash-kumar-aaaa68174/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      src: "devicon",
      url: "http://github.com/aakash2019",
      className: "fa fa-github",
    },
    {
      name: "facebook",
      src: "devicon",
      url: "https://www.facebook.com/aakash.20.12.1999/",
      className: "fa fa-facebook",
    },
    {
      name: "skype",
      src: "devicon",
      url: "https://join.skype.com/invite/WyWt23ASh5rl",
      className: "fa fa-skype",
    },
    {
      name: "whatsapp",
      src: "devicon",
      url: "https://wa.me/+917404396642",
      className: "fab fa-whatsapp",
    },
  ],
  aboutme:
    "I am a self taught Full Stack Web Developer. I am willing to help my clients to develop their ideas into beautiful and smooth web applications. I believe that to be successful in life, one needs to be obsessive with their dreams and keep working towards them. I have completed my Bachelor's degree in Computer Science from Kurukshetra University, Kurukshetra in 2021",
  address: "# 1307/4, Urban Estate Kurukshetra, Haryana",
  mobilenum: "+91 7404396642",
  country: "India",
  website: "https://aakash2019.github.io",
  education: [
    {
      UniversityName: "Kurukshetra University, Kurukshetra",
      specialization: "B.Sc. Computer Science",
      MonthOfJoining: "July",
      YearOfJoining: "2018 -",
      MonthOfPassing: "",
      YearOfPassing: "2021",
      Achievements:
        "Major in Computer Science, Mathematics and Physics. Learnt different programming languages and created various computer projects under the guidance of good teachers.",
    },
    {
      UniversityName: "Aggarsain Public School, Kurukshetra",
      specialization: "Senior Secondary (10+2, Non-Medical)",
      MonthOfPassing: "May",
      YearOfPassing: "2018",
      Achievements: "Studied Maths, Physics, Chemistry, English and Physical Education.",
    },
  ],
  /*work: [
    {
      CompanyName: "Made own projects",
      specialization: "",
      MonthOfJoining: "August",
      YearOfJoining: "2017 -",
      MonthOfLeaving: "",
      YearOfLeaving: "2018",
      Achievements:
        "Learned skills and applied them on different projects. Worked with Git & Github. Scrapped data from APIs and used in projects. Deployed websites online.",
    },
    {
      CompanyName: "Freelancing",
      specialization: "Upwork",
      MonthOfJoining: "November",
      YearOfJoining: "2018 -",
      MonthOfLeaving: "",
      YearOfLeaving: "Present",
      Achievements:
        "Worked with ReactJS, Redux, React Context API, Node.js, Express.js. Relational and Non-relational Database handling and Cloud hosting. Worked with clients from different countries. Developed the ideas of the clients into beautiful web applications.",
    },
  ],*/
  skillsDescription: "My Technical Skills",
  skills: [
    {
      skillname: "MongoDB",
      src: "devicon",
      icon: "devicon-mongodb-plain-wordmark colored",
      description: "Non-relational Database",
    },
    {
      skillname: "Express",
      src: "devicon",
      icon: "devicon-express-original-wordmark",
      description: "Server",
    },
    {
      skillname: "React",
      src: "devicon",
      icon: "devicon-react-original-wordmark colored",
      description: "Frontend Framework",
    },
    {
      skillname: "Node.js",
      src: "devicon",
      icon: "devicon-nodejs-plain-wordmark",
      description: "Backend Framework",
    },
    {
      skillname: "Next.js",
      src: "devicon",
      icon: "devicon-nextjs-original-wordmark",
      description: "Frontend Framework",
    },
    {
      skillname: "Redux & React Context API",
      src: "icon8",
      icon: "https://img.icons8.com/color/96/000000/redux.png",
      description: "State management in ReactJS",
    },
    {
      skillname: "Firebase",
      src: "icon8",
      icon: "https://img.icons8.com/color/96/000000/firebase.png",
      description: "Non-Relational Database",
    },
    {
      skillname: "PostgreSQL",
      src: "devicon",
      icon: "devicon-postgresql-plain-wordmark colored",
      description: "Relational Database",
    },
    {
      skillname: "Material UI",
      src: "icon8",
      icon: "https://img.icons8.com/color/96/000000/material-ui.png",
      description: "CSS Framework",
    },
    {
      skillname: "Tailwind CSS",
      src: "devicon",
      icon: "devicon-tailwindcss-plain colored",
      description: "CSS Framework",
    },
    {
      skillname: "Bootstrap",
      src: "devicon",
      icon: "devicon-bootstrap-plain-wordmark colored",
      description: "CSS Framework",
    },
    {
      skillname: "Git",
      src: "devicon",
      icon: "devicon-git-plain-wordmark colored",
      description: "Version Control",
    },
    {
      skillname: "Github",
      src: "devicon",
      icon: "devicon-github-original-wordmark",
      description: "Hosting & Storing Projects",
    },
    {
      skillname: "Heroku",
      src: "devicon",
      icon: "devicon-heroku-plain-wordmark colored",
      description: "Cloud hosting",
    },
    {
      skillname: "Javascript",
      src: "devicon",
      icon: "devicon-javascript-plain colored",
      description: "Programming Language",
    },
    {
      skillname: "Python",
      src: "icon8",
      icon: "https://img.icons8.com/color/96/000000/python.png",
      description: "Programming Language",
    },
    {
      skillname: "C",
      src: "devicon",
      icon: "devicon-c-plain colored",
      description: "Programming Language",
    },
    {
      skillname: "C++",
      src: "devicon",
      icon: "devicon-cplusplus-line-wordmark colored",
      description: "Programming Language",
    },
    {
      skillname: "HTML5",
      src: "devicon",
      icon: "devicon-html5-plain colored",
      description: "Markup Language",
    },
    {
      skillname: "CSS3",
      src: "devicon",
      icon: "devicon-css3-plain-wordmark colored",
      description: "Style sheet Language",
    },
  ],
  portfolio: [
    {
      name: "SOCIALAPE",
      description:
        "A progressive web application made by using ReactJS & Firebase. It is a social media website where you can interact with other users by creating new screams, liking and commenting on other user's screams. Users can update information in their profile and also get notifications if anybody like or comment on thier scream..",
      link: "https://socialape-e38f4.web.app/",
      skills: [
        {
          skillname: "ReactJS + ",
          src: "devicon",
          icon: "devicon-react-original-wordmark colored",
        },
        {
          skillname: "Node + ",
          src: "devicon",
          icon: "devicon-nodejs-plain-wordmark",
        },
        {
          skillname: "Express + ",
          src: "devicon",
          icon: "devicon-express-original-wordmark",
        },
        {
          skillname: "Firebase + ",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
        {
          skillname: "Redux + ",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/redux.png",
        },
        {
          skillname: "MaterialUI",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/material-ui.png",
        },
      ],
      imgurl: "images/myProjectPics/sa1.png",
      images: [
        { url: "images/myProjectPics/socialape/sa1.png" },
        { url: "images/myProjectPics/socialape/sa2.png" },
        { url: "images/myProjectPics/socialape/sa3.png" },
        { url: "images/myProjectPics/socialape/sa4.png" },
        { url: "images/myProjectPics/socialape/sa5.png" },
      ],
    },
    {
      name: "INSTAGRAM CLONE",
      description: "This is a Frontend clone of INSTAGRAM, which consists of basic functionalities such as creating a new post, like and comment on them. Anybody can login into instagram using their google account and sign out by tapping on Profile picture in header section.",
      link: "https://instagram-three-wine.vercel.app/",
      skills: [
        {
          skillname: "Next.js + ",
          src: "devicon",
          icon: "devicon-react-original-wordmark colored",
        },
        {
          skillname: "Tailwind CSS + ",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
        {
          skillname: "Firebase + ",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
        {
          skillname: "Recoil + ",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
        {
          skillname: "NextAuth + ",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
        {
          skillname: "Vercel",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
      ],
      imgurl: "images/myProjectPics/nc1.png",
      images: [
        { url: "images/myProjectPics/instagramClone/ig1.png" },
        { url: "images/myProjectPics/instagramClone/ig2.png" },
        { url: "images/myProjectPics/instagramClone/ig3.png" },
        { url: "images/myProjectPics/instagramClone/ig4.png" },
        { url: "images/myProjectPics/instagramClone/ig5.png" },
        { url: "images/myProjectPics/instagramClone/ig6.png" },
      ],
    },
    {
      name: "AMAZON CLONE",
      description: "A clone of AMAZON made by using React app. This website uses static data for items, Context API for state management and Firebase for creating users.",
      link: "https://clone-8defd.web.app/",
      skills: [
        {
          skillname: "ReactJS + ",
          src: "devicon",
          icon: "devicon-react-original-wordmark colored",
        },
        {
          skillname: "Context API + ",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
        {
          skillname: "Firebase + ",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
        {
          skillname: "Firebase Authentication",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
      ],
      imgurl: "images/myProjectPics/ac1.png",
      images: [
        { url: "images/myProjectPics/amazonClone/ac1.png" },
        { url: "images/myProjectPics/amazonClone/ac2.png" },
        { url: "images/myProjectPics/amazonClone/ac3.png" },
        { url: "images/myProjectPics/amazonClone/ac4.png" },
        { url: "images/myProjectPics/amazonClone/ac5.png" },
      ],
    },
    {
      name: "COVID-19 TRACKER",
      description:
        "A Covid-19 tracker which tracks the number of Coronavirus patients. This website was created during Coronavirus pandemic to show number of cases, recovered patients and deaths caused by Coronavirus by fetching data from Open Disease Data API and charted it on world map by using LeafletJS.",
      link: "https://covid-19-tracker-b59da.web.app/",
      skills: [
        {
          skillname: "ReactJS + ",
          src: "devicon",
          icon: "devicon-react-original-wordmark colored",
        },
        {
          skillname: "Firebase + ",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
        {
          skillname: "MaterialUI + ",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/material-ui.png",
        },
        {
          skillname: "React Leaflet Map",
          src: "",
          icon: "",
        },
      ],
      imgurl: "images/myProjectPics/ct1.png",
      images: [
        { url: "images/myProjectPics/covidTracker/ct1.png" },
        { url: "images/myProjectPics/covidTracker/ct2.png" },
        { url: "images/myProjectPics/covidTracker/ct3.png" },
        { url: "images/myProjectPics/covidTracker/ct4.png" },
        { url: "images/myProjectPics/covidTracker/ct5.png" },
      ],
    },
    {
      name: "NETFLIX CLONE",
      description: "A Frontend clone of NETFLIX made by using React app and Material UI. This website fetches data of movies and web series from TMDB API.",
      link: "https://netflix-clone-3eb69.web.app/",
      skills: [
        {
          skillname: "ReactJS + ",
          src: "devicon",
          icon: "devicon-react-original-wordmark colored",
        },
        {
          skillname: "Firebase",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
      ],
      imgurl: "images/myProjectPics/nc1.png",
      images: [
        { url: "images/myProjectPics/netflixClone/nc1.png" },
        { url: "images/myProjectPics/netflixClone/nc2.png" },
        // { url: "images/myProjectPics/netflixClone/nc3.png" },
        { url: "images/myProjectPics/netflixClone/nc4.png" },
      ],
    },
    {
      name: "WHATSAPP WEB CLONE",
      description: "A Frontend Whatsapp Web Clone built using ReactJS and Material UI. Anybody can create a new chat group using their google account and chat with other people.",
      link: "https://whatsapp-clone-9b3e5.web.app/",
      skills: [
        {
          skillname: "ReactJS + ",
          src: "devicon",
          icon: "devicon-react-original-wordmark colored",
        },
        {
          skillname: "Firebase",
          src: "icon8",
          icon: "https://img.icons8.com/color/96/000000/firebase.png",
        },
      ],
      imgurl: "images/myProjectPics/wa2.png",
      images: [
        { url: "images/myProjectPics/whatsappClone/wa1.png" },
        { url: "images/myProjectPics/whatsappClone/wa2.png" },
        { url: "images/myProjectPics/whatsappClone/wa3.png" },
        { url: "images/myProjectPics/whatsappClone/wa4.png" },
      ],
    },
  ],
  testimonials: [
    {
      description: "This is a sample testimonial",
      name: "Some technical guy",
    },
    {
      description: "This is a sample testimonial",
      name: "Some technical guy",
    },
  ],
};

export default resumeData;
